import BlogPostAPI from "@api/BlogPost.api";
import type IBlogPost from "@api/models/IBlog";
import BlogListItem from "@core-components/blogs/BlogListItem";
import EPublicRoutes from "@core-types/routes.enum";
import useAppLanguage from "@hooks/language/useAppLanguage";
import { SimpleGrid } from "@mantine/core";
import { useEffect, useState } from "react";

interface Props {
  blogIdToExclude?: string;
}
const RecentBlogs: React.FC<Props> = ({ blogIdToExclude }) => {
  const [recentBlogs, setRecentBlogs] = useState<IBlogPost[]>([]);
  const { locationUrlBuilder, lang } = useAppLanguage();

  useEffect(() => {
    BlogPostAPI.getRecentBlogPosts().then((res) => setRecentBlogs(res.data));
  }, [lang.currentLanguage]);

  return (
    <SimpleGrid cols={{ base: 1, sm: 2, md: 3 }}>
      {recentBlogs
        .filter((blog) => blog.id !== blogIdToExclude)
        .slice(0, 3)
        .map((blog) => (
          <BlogListItem
            key={blog.id}
            description={blog.shortDescription}
            href={locationUrlBuilder(EPublicRoutes.BLOGS, blog.slug)}
            label={blog.title}
            picture={blog.coverImage}
          />
        ))}
    </SimpleGrid>
  );
};

export default RecentBlogs;
